// 中文繁体(Chinese_yy)
export default {
  oneOneClass: "{course}外教1v1",
  learnPracEnFast: "{course}外教1v1",
  htOralClass: "HelloTalk口語課",
  benefits: "4大優勢",
  topicNumber: "800+互動主題",
  dailyBusinessAcademic: "涵蓋商務/留學/生活場景/{test name}",
  englishTutors: "資深外教1對1",
  qualifiedTutors: "資深外教1對1",
  nativeOkAllAges: "嚴選{course}外教，定期考核",
  oneOneLive: "直播互動教學",
  accessToRecord: "視頻授課，課後無限回放",
  personalizedPlan: "量身定制學習方案",
  ensureGoal: "精准定位，1v1私人定制",
  professional: "專業",
  nativeTeam: "外教團隊",
  authenticLanguage: "提供純正地道{language}課堂",
  bgChecked: "高師資",
  experiencedTeachers: "嚴選擁有豐富線上教學經驗的母語外教老師",
  assuredQuality: "嚴把控",
  regularAssess: "多輪培訓考核錄用、全程監督、定期考核",
  assuredSatisfaction: "重體驗",
  teamSizeAndRefund: "2000+優秀外教資源 幫助學員提升英語實力",
  curriculum: "課程設置",
  dailyTalks: "生活口语",
  beginnerInfo: "初級Level 1 - 40課時",
  lessonOverview: "課程概覽",
  beginnerClassIntro:
    "真實再現生活情境，以角色扮演和情景學習等形式，幫助學生快速掌握生活場景中的基本句型和表達，實現開口說。",
  topicEx: "話題實例",
  beginnerTopicEx: "自我介紹、就餐與點餐、興趣愛好",
  mediateInfo: "中級Level 2-3 - 80課時",
  mediateClassIntro:
    "涵蓋80個日常對話中高頻話題，達到對事件的基本描述與觀點的簡單闡述，達到聽得懂有得說。",
  mediateTopicEx: "指路問路、尋醫問診、觀點表達",
  advancedInfo: "高級Level 2-3 - 80課時",
  advancedClassIntro:
    "真實場景對話模擬，甄選時事熱點話題進行深度討論，實現英語流利表達自己思想觀點。",
  advancedTopicEx: "租房買房、聚會邀約、旅遊英語",
  businessLanguage: "商務{language}",
  busElementInfo: "初級Level 1-2 - 40課時",
  busElementClassIntro:
    "由淺入深教授商务{language}，幫助學生收穫外企敲門磚，快速融入國際化企業工作狀態",
  busElementTopicEx: "簡歷準備、求職面試、初入職場",
  busMediateInfo: "中級Level 3-4 - 40課時",
  busMediateClassIntro:
    "還原國內外商務活動的真實場景，提高商務交際能力，真正做到{language}為我所用。",
  busMediateTopicEx: "合同簽訂、商務談判、國際貿易",
  ielts: "雅思實戰",
  languageTests: "等級考試",
  aHundredLessons: "100課時",
  ieltsClassIntro:
    "甄選{test name}高頻話題，快速提升流利度與連貫性，形成{language}思維， 打破瓶頸快速提分。",
  faq: "你關心的",
  questionCn: "問題",
  classLength: "Q1 每節課課程時長是多少？",
  classInfoAndSuggest:
    "A1 試聽課為25分鐘一節。針對基礎較弱的同學，我們建議每課30分鐘以達到更好的場景訓練效果；對於有一定基礎，有較強口語練習或考試需求的同學，我們建議每節課45分鐘來快速提高。",
  lessonForm: "Q2 外教直播課形式如何，是否可以回放？",
  lessonFormInfo:
    "A2我們採用一對一視頻在線課堂，課上和老師根據材料進行情景會話訓練，課後還可以觀看課程回放進行複習哦。",
  lessonPrepare: "Q3 上課前我應該準備什麼？",
  lessonPrepareInfo:
    "A3 一對一課程為在線視頻課程，我們建議您使用平板/電腦上課效果最佳，請在上課前確保自己處於穩定的網絡環境中哦。",
  support: "諮詢",
  limitedOffer: "限時特惠",
  originalPrice: "原價",
  bookNow: "立即搶購試聽",
  successPurchase: "你已成功購買試聽！",
  trialEndAndGoOn:
    "試聽完成後，你可按照月度/季度進行續費學習，持續養成良好的學習習慣～",
  courseAdvisor: "諮詢課程顧問",
  oneLastStep: "只差最後一步啦",
  ticketPrice: "一張電影票的價格就可以提高你的{language}口語能力～",
  perPriceAndOrder: "{price}/次，去預定",
  noThanks: "不了，看看再說",
  unpaidAndProceed: "{language}1對1搶鮮試聽訂單還未支付，點擊繼續",
  halfPrice: "5折搶購{course}外教口語課",
  languageEn: "英語",
  languageKo: "韓語",
  languageEsp: "西班牙語",
  languageFr: "法語",
  languageIt: "意大利語",
  languageRu: "俄羅斯語",
  languageCn: "中文",
  languageJp: "日語",
  courseEn: "英美",
  courseKo: "韓語",
  courseEsp: "西班牙語",
  courseFr: "法語",
  courseIt: "意大利語",
  courseRu: "俄羅斯語",
  courseCn: "中文",
  courseJp: "日語",
  enTestEn: "IELTS",
  koTestEn: "TOPIK",
  espTestEn: "DELE",
  frTestEn: "DELF/DEAL/TE",
  itTestEn: "CILS",
  ruTestEn: "ТРКИ",
  jpTestEn: "JLPT",
  cnTestEn: "HSK",
  jpPrivateClassCn: "1v1私教課",
  jpPracticalCn: "實用日語課",
  jpOfficialAutoCn: "官方標準自研課程",
  jpClassSystemCn: "完整的自研課程體系，270+活動場景",
  jpIdeaCn: "實用日語教學理念",
  jpEmphasisCn: "注重應用場景活動能力的Output",
  jpTutorTimeCn: "外教/時間自由選",
  jpTutorTimeChooseCn: "根據需求，自由選擇外教和時間",
  jpAccessToRecordCn: "在線1v1視頻授課，課後無限回放",
  jpGoodLookCn: "高顏值",
  jpNativeTeamCn: "資深外教團隊",
  jpOnlineCn: "1v1在線教學",
  jpBgCheckedCn: "優師資",
  jpTutorTrainCn: "日本文化廳420H培訓，多年線上教學經驗",
  jpStrictScreenCn: "層層選拔錄用、定期培訓和考核、全程監督",
  jpImproveCn: "優質外教助你日語開口說，提升日語綜合能力",
  jpHtPracticalCn: "HelloTalk實用日語課設置",
  jpBeginnerClassIntroCn:
    "以角色扮演、情景演繹的形式再現生活場景，幫助學生快速地實現用日語簡單地表達自身相關需求。",
  settingEx: "場景實例",
  jpBeginnerExCn: "自我介紹、詢問價格、興趣愛好",
  jpMediateInfoCn: "中級Level 2-3 - 60課時",
  jpMediateClassIntroCn:
    "包含 60 個日常高頻場景，實現用 簡練的日語來描述身邊情況及日常行為，並且對可預測的日常情況 做出基本應對。",
  jpMediateExCn: "受傷看病、描述事件、表達觀點",
  jpAdvancedInfoCn: "高級Level 4 - 30課時",
  jpAdvancedClassIntroCn:
    "甄選生活、旅遊、工作等場景, 實現用日語表達基本生活用語， 能夠就相關情況進行說明。",
  jpAdvancedExCn: "看音樂會、贈送禮物、尋找失物",
  jpBusinessCn: "職場商務",
  jpBusElementInfoCn: "初級Level 1-2 - 60課時",
  jpBusElementClassIntroCn:
    "結合不同場景，由淺入深，實現通過複雜的文章構造，組織語言闡明自己的觀點及議論的框架。",
  jpBusElementExCn: "請假早退、面試禮儀、產品故障",
  jpBusAdvancedInfoCn: "高級Level 3 - 30課時",
  jpBusAdvancedClassIntroCn:
    "還原商務活動的真實場景，以角色扮演的形式再現工作場景，實現用恰當的敬語來準確表達自己的想法。",
  jpBusAdvancedExCn: "工作匯報、指出錯誤、抱怨加班",
  jpSmoothTalkCn: "無障礙溝通",
  jpSixtyLessonsCn: "60課時",
  jpSmoothClassIntroCn:
    "結合職場、經濟、文化等不同場景，能夠選擇最合適的語言準確表達自己的看法，熟練使用各種表達方式。",
  jpClassInfoSuggestCn:
    "A1 試聽課是 25 分鐘。常規課是每節課 45 分鐘。真人在線 1V1 視頻授課，課後還可以觀 看課程回放。",
  jpClassTimeCn:
    "A2 我們的外教老師大都居住在日本，上課時間一般為平時的晚上19點-23點(北京時間) 以及週末。購買課程後，我們會盡量根據您的時間、您喜歡的外教進行排課。",
  jpLessonPrepareInfoCn:
    "A3 由於是線上課，請在上課前確保自己處於穩定的網絡環境中哦。另外，建議您用平板/ 電腦上課效果最佳。",
  jpLimitedOfferCn: "限時特惠 ¥59.9",

  buySomeAndGetExtra: "購買即獲得額外贈送",
  balance: "餘額",
  coins: "{number}HT幣",
  coin: "{number}HT幣",
  extraCoins: "重發{number}",
  continue: "繼續",
  byToppingUpYouAgree: "購買即代表同意",
  topUpAgreement: "《充值協議》",
  htCoin: "HT幣",
  scanCodeToLog: "掃碼登錄",
  bindYourHelloTalkAccount: "用HelloTalk APP 掃碼登錄，綁定賬號後進行充值",
  itemSelection: "套餐選擇",
  paymentAmount: "支付金額",
  topUpSuccessful: "充值成功",
  totalCoinsNumber:
    "你已成功充值{numberone}，並額外獲得{numbertwo}贈送，總計{numberall}",
  ok: "OK",
  payMethods: "使用支付寶&微信掃碼支付",
  alipay: "支付寶",
  weChatPay: "微信支付",
  copyLinkToPay: "請複制鏈接到HelloTalk APP內完成支付",
  paymentFailed: "支付失敗",
  creditCardPay: "使用PayPal&信用卡支付",
  creditCard: "信用卡",
  payssion: {
    // key:value
    purchaseSucceeded: "購買成功",
    topUpSuccessful: "充值成功👏",
    paymentFailed: "支付失敗",
    recharge: "充值",
    VipRecharge: "VIP充值",
    rechargeWithCoins: "HT幣充值",
    oneMonthMember: "一個月會員",
    annualFeeMember: "年費會員",
    oneTimePurchase: "終身會員",
    coins: "{number} HT幣",
    coin: "{number} HT幣",
    extraCoins: "再送{number}",
    extraCoin: "再送{number}",
    continue: "繼續",
    byToppingUpYouAgree: "購買即代表同意",
    rechargePrompt: "溫馨提示:未成年人請在監護人的陪同下或許可下操作",
    toppingUpYouAgree: "《充值協議》",
  },
};
